<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_research_intro')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        Hello, I'm your science advisor, Research is the key to advancing our civilization and unlocking new technologies.
      </p>
      <p class="pb-2">
        Through research, you can improve our ships, discover new building types, enhance resource production, and unlock powerful abilities.
      </p>
      <p class="pb-2">
        Research requires science points <GenericIcon type="science" /> generated by our planets and research facilities.
      </p>
      <p class="pb-2">
        Each technology you research opens up new strategic possibilities and strengthens our empire.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Research" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Research".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        Goto Research
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I'm there
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>